export enum AtaTypes {
  GET_ATAS_REQUEST = '@atas/GET_ATAS_REQUEST',
  GET_ATAS_SUCCESS = '@atas/GET_ATAS_SUCCESS',
  GET_ATAS_FAILURE = '@atas/GET_ATAS_FAILURE',
  UPDATE_CURRENT_PAGE = '@atas/UPDATE_CURRENT_PAGE',
  SEARCH_ATAS_REQUEST = '@atas/SEARCH_ATAS_REQUEST',
  SEARCH_ATAS_SUCCESS = '@atas/SEARCH_ATAS_SUCCESS',
  SEARCH_ATAS_FAILURE = '@atas/SEARCH_ATAS_FAILURE',
}

export interface OrgaoTypes {
  cep: string;
  cidade: string;
  cidade_id: number;
  codigo: string;
  edital_site: string;
  endereco: string;
  estado: string;
  estado_id: number;
  homepage1: string;
  homepage2: string;
  id: number;
  nome: string;
  tipo_orgao: string;
  tipo_orgao_id: number;
  uasg: string;
}

export interface AtaItem {
  atividade: string;
  created: string;
  data_validade: string;
  datahora_abertura: string | null;
  datahora_documento: string | null;
  datahora_prazo: string | null;
  datahora_retirada: string | null;
  datahora_visita: string | null;
  edital: string;
  edital_preco: number;
  edital_tem: boolean;
  id: number;
  itens: string;
  modalidade_id: number;
  modalidade_nome: string;
  modalidade_sigla: string;
  modified: string;
  objeto: string;
  observacao: string;
  orgao: Array<OrgaoTypes>;
  orgao_id: string;
  processo: string;
  tipo_agrupamento_descricao: string;
  tipo_agrupamento_id: number;
  tipo_agrupamento_resumo: string;
  valor_estimado: number;
}

export interface AtaItemTypes {
  _source: {
    atividade: string;
    created: string;
    data_validade: string;
    datahora_abertura: string | null;
    datahora_documento: string | null;
    datahora_prazo: string | null;
    datahora_retirada: string | null;
    datahora_visita: string | null;
    edital: string;
    edital_preco: number;
    edital_tem: boolean;
    id: number;
    itens: string;
    modalidade_id: number;
    modalidade_nome: string;
    modalidade_sigla: string;
    modified: string;
    objeto: string;
    observacao: string;
    orgao: Array<OrgaoTypes>;
    orgao_id: string;
    processo: string;
    tipo_agrupamento_descricao: string;
    tipo_agrupamento_id: number;
    tipo_agrupamento_resumo: string;
    valor_estimado: number;
  };
}

export interface AtasTypes {
  ata: Array<AtaItemTypes>;
  currentPage: number;
  postsPerPage: number;
  total_entries: number;
  atas_status: string;
}

export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface AtasState {
  atas: AtasTypes;
  readonly request: RequestState;
}
